@if (showBanner()) {
  @if (notificationData(); as data) {
    @if (data.header; as header) {
      @if (data.buttonText; as buttonText) {
        <bit-banner [title]="header">
          {{ data.description }}
          <ng-container slot="actions">
            <button
              bitButton
              type="button"
              buttonType="primary"
              (click)="actionButtonClick(data.organizationId)"
            >
              {{ buttonText }}
            </button>
          </ng-container>
        </bit-banner>
      } @else {
        <bit-banner [title]="header" (dismiss)="close()">
          {{ data.description }}
        </bit-banner>
      }
    } @else {
      <bit-banner (dismiss)="close()">
        {{ data.description }}
      </bit-banner>
    }
  }
}

@for (invitation of pendingInvitations(); track invitation.organizationUserId) {
  <bit-banner [title]="'pendingOrganizationInvitation' | i18n">
    {{ "pendingOrganizationInvitationDesc" | i18n: invitation.organizationName }}
    <ng-container slot="actions">
      <button
        bitButton
        type="button"
        buttonType="primary"
        [disabled]="acceptingInvitationId() === invitation.organizationUserId"
        (click)="acceptInvitation(invitation)"
      >
        {{ "acceptInvitation" | i18n }}
      </button>
    </ng-container>
  </bit-banner>
}
